import { render, staticRenderFns } from "./VisibleColumns.vue?vue&type=template&id=1faca84a&scoped=true"
import script from "./VisibleColumns.vue?vue&type=script&lang=js"
export * from "./VisibleColumns.vue?vue&type=script&lang=js"
import style0 from "./VisibleColumns.vue?vue&type=style&index=0&id=1faca84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faca84a",
  null
  
)

export default component.exports